<template>
  <section ref="pc_common"
    :class="`detail detect_deviece_${deviceType} state_${deviceType} chan-07041215`">
    <HeadBar :title="domainConfig['IAmTitle']" :logo="domainConfig['icon']"
      :deviceType="deviceType" />
    <section v-if="pagenum == 0 && novalInfo" class="page-0 pc_padding">
      <!-- <div v-if="deviceType != 'mobile'" class="book-reading-nav pc_padding">
        <div class="book-reading-nav-item contents cursor" @click="toggleContents">
          Contents
          <img src="@/assets/up.png" :class="{'flip':showContents}" alt="">
        </div>
        <div class="book-reading-nav-item goback cursor" @click="gohome()">
          <img src="@/assets/conents-icon.png" alt="">
          Go to Books
        </div>
      </div> -->
      <div class="detail-recommand-banner-row" @click="fullpageclick(1)">
        <div class="detail-recommand-banner-shadow" />
        <img v-lazy="novalInfo.bigImg" class="detail-recommand-banner-img " alt="">
        <div class="recomannd-banner-rate-info-row">
          <div class="recomannd-banner-rate-info-tag">
            <div class="recomannd-banner-rate-info-tag-item" v-html="novalInfo.novelType" />
          </div>
          <div class="recomannd-banner-rate-info-stars-row">
            <img src="@/assets/star.png" alt=""> {{ novalInfo.novelScore }}/10
          </div>
        </div>
      </div>
      <div class="detail-recommand-title" @click="fullpageclick(1)">
        {{ novalInfo.novelName }}
      </div>
      <AdComponent ref="ads-cover-1" class="content pc_padding" :ads="adsensConfig?.cover_1"
        :showDebug="showDebug" />
      <div class="detail-recommand-author" @click="fullpageclick(1)">
        {{ novalInfo.novelAuthorName }}
      </div>
      <div class="detail-recommand-content" @click="fullpageclick(1)"
        v-html="novalInfo.novelStoryIntro" />
      <div class="detail-recommand-btn cursor" @click="gochapter(1)">
        Read Now
      </div>

      <!-- <AdComponent ref="ads-cover-2" class="content pc_padding" :ads="adsensConfig?.cover_2"
        :showDebug="showDebug" /> -->

      <div v-if="hasNext" class="nxt-page-btn cursor" @click="gochapter(1)">
        Next Page <img class="arrow" src="@/assets/arror.png" alt="">
      </div>
    </section>
    <section v-if="pagenum != 0 && novalInfo" class="page-n pc_padding">
      <div v-if="deviceType=='mobile' && pagenum!=0" class="page-section prev-page cursor"
        @click="gochapter(parseInt(pagenum)-1)" />
      <div v-if="deviceType=='mobile' && hasNext" class="page-section next-page cursor"
        @click="gochapter(parseInt(pagenum)+1)" />
      <div class="book-reading-nav">
        <div class="book-reading-nav-item contents cursor" @click="toggleContents">
          Contents
          <img src="@/assets/up.png" :class="{'flip':showContents}" alt="">
        </div>
        <div class="book-reading-nav-item goback cursor" @click="gohome()">
          <img src="@/assets/conents-icon.png" alt="">
          Go to Books
        </div>
      </div>

      <div class="book-reading-content-container">
        <div v-show="showContents" class="contents-menu">
          <ul>
            <li v-for="(item, index) in novalInfo.novelChapter" :key="index" class="cursor"
              :class="{'active':pagenum == index}" @click="gochapter(index)">
              {{ item }}
            </li>
          </ul>
        </div>
        <div v-if="novalDetail && novalDetail.length>0" class="book-reading-content-txt-container">
          <div class="book-reading-content-row">
            <div class="chapter-name" v-html="novalDetail[0].chapterName" />
            <img v-lazy="novalInfo.bigImg" class="detail-recommand-banner-img reader-banner cursor"
              alt="" @click="gochapter(0)">
            <AdComponent ref="ads-content-1" class="content " :ads="adsensConfig?.content_1"
              :showDebug="showDebug" />
            <div v-for="(data,i) in formattedContent" :key="`novel_${i}`" class="chapter-content"
              v-html="data.content" />
            <AdComponent ref="ads-content-2" class="content " :ads="adsensConfig?.content_2"
              :showDebug="showDebug" />
          </div>

          <div v-if="deviceType!='mobile'" class="pagenation-row">
            <div v-if="pagenum!=0" class="page-fixed prev-page cursor"
              @click="gochapter(parseInt(pagenum)-1)">
              <img src="@/assets/page-arr.png" alt=""> Prev
            </div>
            <div v-if="hasNext" class="page-fixed next-page cursor"
              @click="gochapter(parseInt(pagenum)+1)">
              <img src="@/assets/page-arr.png" alt=""> Next
            </div>
          </div>
        </div>
      </div>

      <!-- 背景遮挡层 -->
      <div v-if="showContents && deviceType=='mobile'" class="overlay" @click="toggleContents" />
    </section>
    <FootBar v-if="pagenum != 0 && deviceType=='mobile'" :deviceType="deviceType" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import adMixin from '@/mixin/adMixin.js';
import adTrackingMixin from '@/mixin/adTrackingMixin.js';
import AdComponent from '@/pages/components/AdComponent.vue'
import HeadBar from '@/pages/components/head.vue';
import FootBar from '@/pages/components/footer.vue';
import '@/css/common.scss';
import '@/css/detail.scss'

export default {
  name: 'Detail',
  components: {
    AdComponent,
    HeadBar,
    FootBar
  },
  mixins: [adMixin, adTrackingMixin], 
  data () {
    return {
      pagenum: null,
      bookname: null,
      bookid: null,
      showContents: false,
      novalDetail: null,
      novalInfo: null,
      hasNext: false,
    };
  },
  metaInfo () {
    return {
      title: this.novalInfo?.novelName ? `${this.novalInfo.novelName} | ${this.domainConfig["IAmURL"]}` : `${this.domainConfig["IAmURL"]}`,
      meta: [
        {
          name: 'description',
          content: this.novalInfo?.novelStoryIntro ? this.novalInfo.novelStoryIntro : '',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'showDebug',
      'deviceType',
      'host',
      "adsensConfig",
      'adPosConfig',
      "domainConfig"
    ]),
    formattedContent () {
      return this.novalDetail.map(chapter => ({
        ...chapter,
        content: chapter.content.replace(/\n/g, '<br>')  // 替换换行符为 <br> 标签
      }));
    }
  },
  created () {
    const { bookname, pagenum, id } = this.$route.params
    console.log(bookname, pagenum, id);
    this.pagenum = pagenum
    this.bookname = bookname
    this.bookid = id

  },
  async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
  async mounted () {
    console.log(`-------------------${this.$options.name} mounted`)
    await this.getDetail(this.pagenum)
   
    // 使用防抖包装滚动事件
    this.onScroll = this.debounce(this.onScroll.bind(this), 300);
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll);

    // 在页面ready后执行showPos方法
    this.$nextTick(() => {
      setTimeout(() => {
        this.showPos();
      }, 1000); // 延迟1秒执行，确保页面元素已完全加载
    });
  },
  deactivated () {
    console.log(`${this.$options.name} Component deactivated-----------`);
  },
  beforeDestroy () {
    console.log(`-------------------${this.$options.name} beforeDestroy`);
    // 组件销毁时移除滚动事件监听
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    fullpageclick () {
      if (this.deviceType == 'mobile') {
        this.gochapter(1)
      }
    },
    gohome () {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/library${fullQueryString}`
    },
    toggleContents () {
      this.showContents = !this.showContents;
    },
    gochapter (page) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      console.log(page);
      if (this.pagenum == page) return
      this.pagenum = page
      window.location.href = `${channel}/${this.bookname}/${this.bookid}/${page}${fullQueryString}`
    },
    //shuju
    async getDetail (page) {
      try {
        const res = await this.$global.server.getDetail({
          summaryId: parseInt(this.bookid),
          chapterNum: parseInt(page)
        })
        console.log(res)
        this.novalDetail = res.data.chapterList
        this.novalInfo = res.data.summaryInfo
        this.hasNext = res.data.hasNext
      } catch (err) {
        console.log(err)
      }
    },
    async getTagList () {
      try {
        const res = await this.$global.server.getTagList({ type: '3D' })
        console.log(res)
        this.tagList = res.data
      } catch (err) {
        console.log(err)
      }
    },
    async getImages () {
      try {
        const params = {
          pageNum: this.page,
          pageSize: 30,
          type: '3D'
        };

        // 只有当 this.tag 不为 null 时，才添加 tag 字段
        if (this.activeTag !== null) {
          params.tag = this.activeTag;
        }

        const res = await this.$global.server.getImages(params);
        console.log(res)
        console.log('iiiiiiiiii');
        if (res.code == 200) {
          let data = res.data.photos
          this.images.push(...data)
          this.hasNext = res.data.hasNext
          this.page++;
        }
      } catch (err) {
        console.log(err)
      }
    },
    seclecTag (tag) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/tag/${tag}${fullQueryString}`
    },
    choosePic (id) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${id}${fullQueryString}`
    },
    //pubu
    loadItems () {
      if (this.isLoading) return; // 如果已经在加载，则不重复加载
      this.isLoading = true; // 设置加载状态

      // 模拟异步加载
      setTimeout(() => {
        const newItems = Array.from({ length: 20 }, (_, i) => ({
          src: `https://via.placeholder.com/${i + 1}00x${i + 2}00?text=Item+${i + 1 + this.page * 10}`,
          alt: `Item ${i + 1 + this.page * 10}`,
        }));
        this.items.push(...newItems);
        this.page++;
        this.isLoading = false; // 加载完成后重置加载状态
      }, 500);
    },
    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    onScroll () {
      // 获取文档的总高度
      const documentHeight = document.documentElement.scrollHeight;
      // 当前滚动的高度
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // 视口的高度
      const windowHeight = window.innerHeight;

      // 在滚动时执行 showPos 方法，获取当前可视范围内的广告坐标
      this.showPos();

      // 当滚动距离接近底部2000px时触发
      if (scrollTop + windowHeight >= documentHeight - 2000) {
        console.log('加载');
        // this.getImages();
      }
    },
    //广告相关start
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.home.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    shouldDetailInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.detail.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    //广告相关end

    //ciyi

    goto (name) {
      this.$router.push({ name: name });
    },

    // 显示当前屏幕可视范围内的广告坐标
    showPos () {
      console.log('执行showPos方法，显示当前可视范围内的广告坐标');

      // 获取所有广告元素
      const adElements = document.querySelectorAll('ins.adsbygoogle');
      const visibleAds = [];

      // 当前屏幕可视区域信息
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // 遍历所有广告元素，找出在可视范围内的
      adElements.forEach((adElement, index) => {
        // 使用 getBoundingClientRect 获取元素相对于视口的位置
        const rect = adElement.getBoundingClientRect();

        // 检查元素是否在视口中可见（至少部分可见）
        // rect.top 和 rect.left 是相对于视口左上角的坐标
        const isVisible = !(
          rect.bottom < 0 ||   // 元素底部在视口顶部以上
          rect.top > windowHeight ||  // 元素顶部在视口底部以下
          rect.right < 0 ||  // 元素右侧在视口左侧以外
          rect.left > windowWidth  // 元素左侧在视口右侧以外
        );

        if (isVisible) {
          // 保持与 setupIframeTracking 方法中相同的数据格式
          const transformData = {
            insX: Math.round(rect.left),
            insY: Math.round(rect.top),
            insHeight: Math.round(rect.height),
            windowWidth: windowWidth,
            windowHeight: windowHeight
          };

          visibleAds.push(transformData);
          console.log(`可视广告 #${index}:`, transformData);
        }
      });

      console.log('可视范围内的广告数量:', visibleAds.length);
      console.log('可视范围内的广告坐标:', visibleAds);

      // 即使没有可见广告，也会发送空数组
      this.$adPosition(JSON.stringify(visibleAds))
      return visibleAds;
    },

    // 计算元素在视口中的可见比例
    calculateVisibility (rect, windowWidth, windowHeight) {
      // 计算元素在视口内可见部分的面积
      const visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      if (visibleWidth <= 0 || visibleHeight <= 0) return 0;

      // 元素的总面积
      const totalArea = rect.width * rect.height;
      // 可见面积
      const visibleArea = visibleWidth * visibleHeight;

      // 返回百分比，四舍五入到整数
      return Math.round((visibleArea / totalArea) * 100);
    },

  }
};
</script>
